<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title">فرم درخواست گواهی نامه مرجع</h5>
    <form>


      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Description </label>
          <input disabled type="text" value="{{selected_record.description}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Manufacturer </label>
          <input disabled type="text" value="{{selected_record.manufacturer}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Model </label>
          <input disabled type="text" value="{{selected_record.model}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Code BEHFA </label>
          <input disabled type="text" value="{{selected_record.codeBEHFA}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

      </div>
      <!--
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Certificate No. </label>
          <input disabled type="text" value="{{selected_record.certificateNo}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Cal. Due </label>
          <input disabled type="text" value="{{selected_record.calDue}}" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>
      -->
    </form>
  </div>
</div>